import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { Trans } from 'helpers/i18n';
import Row, { Col } from 'components/row';

import { sectionId, renderLinkTerms } from '../page-terms';

import 'styles/domik/section-terms/_page-terms.scss';

const bemClasses = new Bem('pageTerms');

export default class DocPrivacyPolicy extends Component {
  static propTypes = {
    blockRef: PropTypes.func,
    blockId: PropTypes.string
  };

  render() {
    const { blockRef, blockId } = this.props;

    return (
      <div
        {...bemClasses('section', 'privacyPolicy')}
        ref={blockRef}
        id={blockId}
      >
        <Trans lang="ru">
          <Row {...bemClasses('rowTopic')} mpColumn>
            <Col allPr={0}>
              <div {...bemClasses('text', 'h2')}>
                <h2 children="Политика конфиденциальности сайта Domik.ua" />
              </div>
            </Col>
          </Row>
          <div {...bemClasses('text')}>
            <p>
              Данная Политика конфиденциальности является неотъемлемой частью&ensp;
              {renderLinkTerms.call(this, sectionId[0], 'Пользовательского соглашения сайта Domik.ua')}
              &ensp;(далее ー Соглашение) и принимается Пользователем вместе с принятием Соглашения.
            </p>
          </div>
          <ol {...bemClasses('ol', 'list')}>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Определение терминов" />
              <div {...bemClasses('text')}>
                <p children="Термины, используемые в настоящей Политике Конфиденциальности, имеют следующее значение:" />
              </div>
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Персональные данные</b> ー сведения или совокупность сведений о физическом лице, которое идентифицировано или может быть конкретно идентифицировано.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Обработка персональных данных</b> ー любое действие или совокупность действий, таких как сбор, регистрация, накопление, хранение, адаптация, изменение, восстановление, использование и распространение (реализация, передача), обезличивание, уничтожение персональных данных, в том числе с использованием информационных (автоматизированных) систем.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Распорядитель персональных данных</b> ー физическое или юридическое лицо, которому владельцем персональных данных или законом предоставлено право обрабатывать эти данные от имени владельца.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Регистрационная форма</b> ー электронный регистрационный документ, который заполняет Пользователь, проходя процедуру Регистрации на Портале.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Cookie</b> ー фрагмент данных, созданный программно-аппаратным комплексом, на котором размещён Портал, и сохранённый в компьютере Пользователя в форме одного или нескольких файлов. Cookie не содержит персональных данных и их загрузка в компьютер Пользователя может быть заблокирована Пользователем в любой момент.</span>
                </li>
              </ol>
              <div {...bemClasses('text', 'bold')}>
                <p children="Остальные термины употребляются в соответствии с Законом Украины «О защите персональных данных» и Соглашением." />
              </div>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Предмет соглашения" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Пользователь даёт Компании своё согласие на обработку своих персональных данных, таких как имя Пользователя, регион проживания, адрес электронной почты, контактный телефон, ip-адрес, другие контактные данные Пользователя, которые он предоставляет Компании при Регистрации, размещении объявлений, комментировании новостей на Портале, а также сообщения, письма, заявления, которые Пользователи передают друг другу.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Целью обработки персональных данных Пользователя является необходимость идентифицировать Пользователя при использовании им Портала и Сервисов; обеспечение обслуживания Пользователей, в том числе для создания Аккаунта и управления им; решения технических трудностей и доступа к различным Сервисам и функциям Портала; контроль общей и индивидуальной активности Пользователей, такой как поиск по ключевым словам, активности по публикациям объявлений; управление трафиком на Сайте; установление и поддержание контакта с Пользователем через любые доступные каналы связи или разрешенных маркетинговых коммуникаций; проведение научно-исследовательской и аналитической активности с целью улучшения Портала и Сервисов; обеспечение соблюдения Пользовательского соглашения Портала, включая борьбу с мошенничеством и оскорблениями; сбор статистических данных.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Распорядителем Базы персональных данных Пользователей является Компания. База персональных данных Пользователей находится по адресу Компании.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Компания не собирает и не обрабатывает персональные данные о расовом или этническом происхождении, политических, религиозных или мировоззренческих убеждениях, членстве в политических партиях, профессиональных союзах и подобную информацию.</span>
                </li>
              </ol>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Обработка персональных данных Пользователя" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Персональные данные, добровольно предоставленные Пользователем для целей, указанных в п. 2.2 данной Политики Конфиденциальности, обрабатываются вручную или с помощью электронных средств в соответствии с требованиями, установленными Законом Украины «О защите персональных данных» от 1 июня 2010 года № 2297-VI.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Компания имеет право загружать на компьютер Пользователя файлы Cookie (если Пользователь не ограничил данную возможность в своем веб-браузере), а также получать, сохранять, обрабатывать и использовать информацию, которая содержится в Cookie.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Компания имеет право обрабатывать персональные и другие данные Пользователя на протяжении всего срока, который необходим для реализации целей указанных в п. 2.2 данной Политики Конфиденциальности, если другое не предусмотрено действующим законодательством Украины.</span>
                </li>
              </ol>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Защита персональных данных Пользователя:" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Компания обязуется обеспечить защиту персональных данных Пользователей от несанкционированного доступа третьих лиц.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Компания не использует и не обрабатывает персональные данные Пользователей иначе, чем указано в данной Политике Конфиденциальности, а также, без согласия Пользователя, не передает их третьим лицам, кроме как:</span>
                  <ol {...bemClasses('ol', 'list')}>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')}>По обоснованным запросам государственных органов, имеющих право истребовать и получать такие данные.</span>
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')}>В том случае, если по мнению Компании, Пользователь нарушает условия пользовательского соглашения и/или Ключевых документов.</span>
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')}>В других случаях, прямо предусмотренных законодательством Украины.</span>
                    </li>
                  </ol>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Пользователь имеет право изменить или удалить свои персональные данные, оставленные им на Портале.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Компания не несёт ответственности за распространение персональных данных Пользователя, а также за другие убытки, причинённые Пользователю при несоблюдении им условий Соглашения и Ключевых документов, а также его халатного отношения к обеспечению безопасности и защите персональных данных.</span>
                </li>
              </ol>
            </li>
          </ol>
        </Trans>
        <Trans lang="ua">
          <Row {...bemClasses('rowTopic')} mpColumn>
            <Col allPr={0}>
              <div {...bemClasses('text', 'h2')}>
                <h2 children="Політика конфіденційності сайту Domik.ua" />
              </div>
            </Col>
          </Row>
          <div {...bemClasses('text')}>
            <p>
              Дана Політика конфіденційності є невід'ємною частиною&ensp;
              {renderLinkTerms.call(this, sectionId[0], 'Угоди сайту Domik.ua')}
              &ensp;(далі ー Угода) і приймається Користувачем разом із прийняттям Угоди користувача.
            </p>
          </div>
          <ol {...bemClasses('ol', 'list')}>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Визначення термінів" />
              <div {...bemClasses('text')}>
                <p children="Терміни, які використовуються в цій Політиці Конфіденційності, мають таке значення:" />
              </div>
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Персональні дані</b> ー відомості чи сукупність відомостей про фізичну особу, яка ідентифікована або може бути конкретно ідентифікована.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Обробка персональних даних</b> ー будь-яка дія або сукупність дій, таких як збір, реєстрація, накопичення, зберігання, адаптація, зміна, відновлення, використання і поширення (розповсюдження, реалізація, передача), знеособлення, знищення персональних даних, у тому числі з використанням інформаційних ( автоматизованих) систем.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Розпорядник персональних даних</b> ー фізична або юридична особа, якій власником персональних даних або законом надано право обробляти ці дані від імені власника.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Реєстраційна форма</b> ー електронний реєстраційний документ, який заповнює Користувач, проходячи процедуру реєстрації на Порталі.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Cookie</b> ー фрагмент даних, створений програмно-апаратним комплексом, на якому розміщений Портал, і збережений в комп'ютері Користувача у формі одного або декількох файлів. Cookie не містить персональних даних та їх завантаження в комп'ютер користувача може бути заблокована Користувачем в будь-який момент.</span>
                </li>
              </ol>
              <div {...bemClasses('text', 'bold')}>
                <p children="Інші терміни вживаються відповідно до Закону України «Про захист персональних даних» та Угоди." />
              </div>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Предмет згоди" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Користувач дає Компанії згоду на обробку своїх персональних даних, таких як ім'я Користувача, регіон проживання, адреса електронної пошти, контактний телефон, ip-адреси, інші контактні дані Користувача, які він надає Компанії під час Реєстрації, розміщення оголошень, коментування новин на Порталі, а також повідомлення, листи, заяви, які Користувачі передають один одному.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Метою обробки персональних даних Користувача є необхідність ідентифікувати Користувача при використанні ним Порталу і Сервісів; забезпечення обслуговування користувачів, в тому числі для створення Акаунта і управління ним; вирішення технічних труднощів і доступу до різних Сервісів і функцій Порталу; контроль загальної та індивідуальної активності користувачів, такий як пошук за ключовими словами, активності за публікаціями оголошень; управління трафіком на Сайті; встановлення і підтримання контакту з Користувачем через будь-які доступні канали зв'язку або дозволених маркетингових комунікацій; проведення науково-дослідницької та аналітичної активності з метою поліпшення Порталу і Сервісів; забезпечення дотримання Правил користування Порталу, включаючи боротьбу з шахрайством і образами; збір статистичних даних.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Розпорядником Бази персональних даних користувачів є Компанія. База персональних даних користувачів знаходиться за адресою Компанії.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Компанія не збирає і не обробляє персональні дані про расове або етнічне походження, політичні, релігійні або світоглядні переконання, членство в політичних партіях та професійних спілках і подібну інформацію.</span>
                </li>
              </ol>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Обробка персональних даних Користувача" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Персональні дані, добровільно надані Користувачем для цілей, зазначених у п. 2.2 даної Політики Конфіденційності, обробляються вручну або за допомогою електронних засобів відповідно до вимог, встановлених Законом України «Про захист персональних даних» від 1 червня 2010 № 2297-VI.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Компанія має право завантажувати на комп'ютер користувача файли Cookie (якщо Користувач не обмежив дану можливість у своєму веб-браузері), а також отримувати, зберігати, обробляти і використовувати інформацію, яка міститься в Cookie.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Компанія має право обробляти персональні та інші дані Користувача протягом усього терміну, який необхідний для реалізації цілей зазначених в п. 2.2 даної Політики Конфіденційності, якщо інше не передбачено чинним законодавством України.</span>
                </li>
              </ol>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Захист персональних даних Користувача:" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Компанія зобов'язується забезпечити захист персональних даних користувачів від несанкціонованого доступу третіх осіб.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Компанія не використовує і не обробляє персональні дані користувачів інакше, ніж зазначено в цій Політиці Конфіденційності, а також, без згоди Користувача, що не передає їх третім особам, крім як:</span>
                  <ol {...bemClasses('ol', 'list')}>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')}>За обґрунтованим запитом державних органів, що мають право подавати заявки та отримувати такі дані.</span>
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')}>У тому випадку, якщо на думку Компанії, Користувач порушує умови угоди і/або Ключових документів.</span>
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')}>В інших випадках, прямо передбачених законодавством України.</span>
                    </li>
                  </ol>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Користувач має право змінити або видалити свої персональні дані, залишені ним на Порталі.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Компанія не несе відповідальності за поширення персональних даних Користувача, а також за інші збитки, завдані Користувачеві при недотриманні ним умов Угоди та Ключових документів, а також його халатного відношення до забезпечення безпеки і захисту персональних даних.</span>
                </li>
              </ol>
            </li>
          </ol>
        </Trans>
      </div>
    );
  }
}
